import { render, staticRenderFns } from "./userMainGolomt.vue?vue&type=template&id=ab26961e&scoped=true"
import script from "./userMainGolomt.vue?vue&type=script&lang=js"
export * from "./userMainGolomt.vue?vue&type=script&lang=js"
import style0 from "./userMainGolomt.vue?vue&type=style&index=0&id=ab26961e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab26961e",
  null
  
)

export default component.exports